import React, { useEffect, useState } from 'react';
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath';
import dayjs from "dayjs";

interface DocumentProps {
  logoSrc?: string;
  clientName?: string;
  address?: string;
  cityStateZip?: string;
  projectNumber?: string;
  date?: string;
  heading?: string;
  heading2?: string;
  bodyContent?: string;
  bodyContent2?: string;
  footerContent?: string;
  selectedContentId?: string;
  pdf2?: boolean;
  printRef?: any;
  footer2?:any;
  onRenderReady?: () => void;


}

export const ReusableDocumentComponent: React.FC<DocumentProps> = ({
  logoSrc,
  clientName = '',
  address = '',
  cityStateZip = '',
  projectNumber = '',
  heading = '',
  bodyContent = '',
  footerContent = '',
  selectedContentId = '',
  bodyContent2 = '',
  printRef,
  onRenderReady,
  footer2,
  heading2 = '',
  pdf2

}) => {



  const formatDate = (date: Date | string) => {
    return dayjs(date).format("MMM-D-YYYY").toUpperCase();
  };
  const formattedDate = formatDate(new Date());

  useEffect(() => {
    if (clientName || address || cityStateZip || projectNumber) {
      onRenderReady?.();
    }
  }, []);
  
  return (
    <div className="p-5 position-relative " style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden", pageBreakAfter: "always" }} id={selectedContentId} ref={printRef} >
      <div className="row mb-6 justify-content-between align-items-center">
        <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
          <div className='d-flex align-items-center justify-content-center text-center'>
            <ImageWithBasePath
              src={logoSrc || 'assets/img/logo.svg'}
              className=""
              alt="Logo"
              width={300}
              height={68}
            />
          </div>
        </div>
        <div className='col-md-6 d-flex flex-column justify-content-center align-items-center' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
          <div className="" style={{ textAlign: 'justify' }}>
            <div className='d-flex mb-2 f-f fs-16'>
              <p className="text-sm w-20 mb-0 ">Buyer's Name:</p>
              <p className="text-sm mb-0"> {clientName}</p>
            </div>
            <div className='d-flex mb-2 f-f fs-16'>
              <p className="text-sm w-20 mb-0">Address:</p>
              <p className="text-sm  mb-0"> {address}</p>
            </div>
            <div className='d-flex mb-2 f-f fs-16'>
              <p className="text-sm w-20 mb-0">City, State, ZIP:</p>
              <p className="text-sm  mb-0"> {cityStateZip}</p>
            </div>
            <div className='d-flex mb-2 f-f fs-16'>
              <p className="text-sm w-20 mb-0">Project#: </p>
              <p className="text-sm  mb-0"> {projectNumber}</p>
            </div>
            {/* <div className='d-flex mb-2 f-f fs-16'>
                <p className="text-sm w-20 mb-0">Date: </p>
                <p className="text-sm  mb-0">{formattedDate}</p>
              </div> */}
          </div>
        </div>
      </div>
      <div>
        <h4 className="text-center font-bold  mb-4 mt-3 fs-19 f-f">{heading}</h4>
        <div className="mb-6 text-gray-700 fs-13 f-f ">
          <div className="mb-6" style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: bodyContent }} />
        </div>
      </div>
      {footer2 ===true ? (
        <>
          <div className='d-flex justify-content-around mt-5 f-f'>
            <p>Buyer: ________________________________</p>
            <p>Date: {formattedDate}</p>
          </div>
          <div className='d-flex justify-content-around f-f'>
            <p>Buyer: ________________________________</p>
            <p>Date: {formattedDate}</p>
          </div>
        </>
      )
        : (
          <>
            <div className='d-flex justify-content-around mt-5 f-f'>
              <p>Airoom Client: __________________________</p>
              <p>Date: {formattedDate}</p>
            </div>
            <div className='d-flex justify-content-around f-f'>
              <p>Airoom Client: __________________________</p>
              <p>Date: {formattedDate}</p>
            </div>
          </>
        )
      }
      <div className='d-flex justify-content-around f-f' dangerouslySetInnerHTML={{ __html: footerContent }} />

      {/* <div className='d-flex justify-content-around'>
            <p>Airoom Rep __________________________</p>
            <p>Date: __________________________</p>
          </div> */}
      <div className='footer position-absolute w-100 mt-3 f-f fs-16 ' style={{ left: 0, bottom: 0 }}>

        <hr className="border-gray-300 bottom-0 my-4 mt-5" />
        <p className='text-center fs-10 f-f fw-600'>DESIGN & BUILD SHOWROOM | 6825 N. LINCOLN AVE., LINCOLNWOOD IL 60712 | 847-485-1763
          <br />
          DESIGN STUDIO | 36 S. WASHINGTON ST., HINSDALE IL 60521 | 630-280-3380
          <a href='https://Airoom.com'> Airoom.com</a>
        </p>
      </div>
    </div>
  );
};


